<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure_1" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label=" Page vi. " class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label=" Page vii. " class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>You live in Detroit and also work in the newspaper industry. Are you a glutton for punishment?</p>
<p class="ept">—Stephen Colbert to Stephen Henderson on <i>The Colbert Report</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gallagher-0008.vue?8e578fa6